// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dp3r","expireSoon":"styles_expireSoon__3LGp8"};